import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";

export default function Empresa() {
  const { token } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    nombre_fiscal: "",
    cif: "",
    direccion: "",
    telefono: "",
    email: "",
    logo: null,
  });

  const [previewLogo, setPreviewLogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  // Cargar datos de la empresa al montar
  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const { data } = await api.get("/empresa", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setFormData({
          nombre_fiscal: data.nombre_fiscal || "",
          cif: data.cif || "",
          direccion: data.direccion || "",
          telefono: data.telefono || "",
          email: data.email || "",
          logo: null, // no sobrescribimos el logo
        });

        if (data.logo_url) setPreviewLogo(data.logo_url);
        //console.log(data.logo_url);
        setLoading(false);
      } catch (error) {
        setMessage("No se pudo cargar la información de la empresa");
        setLoading(false);
      }
    };

    if (token) fetchEmpresa();
  }, [token]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "logo") {
      const file = files[0];
      setFormData({ ...formData, logo: file });
      if (file) setPreviewLogo(URL.createObjectURL(file));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("nombre_fiscal", formData.nombre_fiscal || "");
      formDataToSend.append("cif", formData.cif || "");
      formDataToSend.append("direccion", formData.direccion || "");
      formDataToSend.append("telefono", formData.telefono || "");
      formDataToSend.append("email", formData.email || "");
      if (formData.logo) formDataToSend.append("logo", formData.logo);

      await api.post("/empresa", formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setMessage("Datos de la empresa actualizados correctamente");
    } catch (error) {
      setMessage(error.response?.data?.message || "Error al actualizar empresa");
    }
  };

  if (loading)
    return <p className="text-center mt-5">Cargando datos de empresa...</p>;

  return (
    <div className="container-fluid">
        <h1 className="fs-3 fw-bold">Datos de empresa</h1>
        <div className="mt-3">
          {message && (
            <div
              className="alert py-2 px-3"
              style={{
                backgroundColor: "#FFF4E6",
                color: "#FF7A00",
                border: "1px solid #FFB366",
                fontSize: "0.95rem",
              }}
            >
              {message}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Nombre Fiscal</label>
                <input
                  type="text"
                  name="nombre_fiscal"
                  className="form-control"
                  value={formData.nombre_fiscal}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">CIF</label>
                <input
                  type="text"
                  name="cif"
                  className="form-control"
                  value={formData.cif}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>
              <div className="col-md-12">
                <label className="form-label">Dirección</label>
                <input
                  type="text"
                  name="direccion"
                  className="form-control"
                  value={formData.direccion}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Teléfono</label>
                <input
                  type="text"
                  name="telefono"
                  className="form-control"
                  value={formData.telefono}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Correo electrónico</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>
              <div className="col-md-12">
                <label className="form-label">Logo</label>
                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  className="form-control"
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                />
                <div className="mt-3 text-center">
                  {previewLogo ? (
                    <img
                      src={previewLogo}
                      alt="Logo empresa"
                      className="rounded-circle shadow-sm"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        border: "3px solid #FF7A00",
                      }}
                    />
                  ) : (
                    <div className="text-muted fst-italic">No hay logo disponible</div>
                  )}
                </div>
              </div>
            </div>
            <div className="text-center">
              <button
                type="submit"
                className="btn w-100 mt-4"
                style={{
                  backgroundColor: "#FF7A00",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "1rem",
                }}
              >Guardar Datos
              </button>
            </div>
            
          </form>
        </div>
      </div>
  );
}
